import axios from 'axios';

export const notificationsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/notifications`,
    headers: {
        'Content-Type': 'application/json'
    }
})